import { render, staticRenderFns } from "./CodeEditorMenu.vue?vue&type=template&id=2ba142ca&scoped=true&"
import script from "./CodeEditorMenu.vue?vue&type=script&lang=js&"
export * from "./CodeEditorMenu.vue?vue&type=script&lang=js&"
import style0 from "./CodeEditorMenu.vue?vue&type=style&index=0&id=2ba142ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba142ca",
  null
  
)

export default component.exports